"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Menu = require("@react/react-spectrum/Menu");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Props is spread here since we are wrapping a react-spectrum component.
var CommentMenuItem = /*#__PURE__*/_react.default.memo(function (_ref) {
  var icon = _ref.icon,
      onMenuItemSelect = _ref.onMenuItemSelect,
      value = _ref.value,
      visible = _ref.visible,
      isDisabled = _ref.isDisabled,
      props = _objectWithoutProperties(_ref, ["icon", "onMenuItemSelect", "value", "visible", "isDisabled"]);

  return visible ? /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, _extends({
    disabled: isDisabled,
    onClick: onMenuItemSelect
  }, props, {
    className: "comment-action"
  }), icon, value) : null;
});

CommentMenuItem.defaultProps = {
  icon: null,
  isDisabled: false,
  value: null,
  visible: false
};
CommentMenuItem.propTypes = {
  icon: _propTypes.default.any,
  isDisabled: _propTypes.default.bool,
  onMenuItemSelect: _propTypes.default.func.isRequired,
  value: _propTypes.default.any,
  visible: _propTypes.default.bool
};
CommentMenuItem.displayName = 'CommentMenuItem';
var _default = CommentMenuItem;
exports.default = _default;